<ion-router-outlet *ngIf="!showMenu"></ion-router-outlet>
<app-navigation-sidebar *ngIf="showMenu"></app-navigation-sidebar>

<p-toast></p-toast>
<div class="status-bar-background"></div>
